import data from "data/Project";
import ProjectItem from "./ProjectItem";

export default function Project() {
  return (
    <div id="Projects" className="max-w-3xl pt-20 mx-auto mb-20 px-4">
      <h3 className="font-bold text-lg sm:text-xl mb-12 dark:text-white">
        Projects
      </h3>
      <div>
        {data.map((data, i) => (
          <ProjectItem key={i} data={data} />
        ))}
      </div>

      <hr className="mt-5" style={{ color: "#f1f1f1" }} />
    </div>
  );
}
